export default __webpack_public_path__ + "static/media/Focus Fire.24bdeec4.png";